<template>

  <div v-for="(coursesGroupedByMonth, classCategory, index) in coursesGroupedByClassGroupedByMonth" :key="classCategory" class="month-group my-12">
  <h3>
    <span class="bg-blue-800 inline-block w-6 h-6 text-center rounded-full font-bold text-blue-200 !text-base">{{ index +1 }}</span>
    Wann möchtest du den Führerscheinkurs für <b>{{ resolveClassCategory(classCategory) }}</b> bevorzugt starten?
  </h3>
    <div v-if="isEmpty(coursesGroupedByMonth)">
      <span class="text-orange-500 text-sm my-4 block">Es wurden keine geplanten Kurse gefunden. Du kannst jedoch eine Anfrage absenden. Die Fahrschule wird sich anschließend mit dir in Verbindung setzen. Falls du dies nicht möchtest, gehe einen Schritt zurück und entferne die Führerscheinklasse.</span>
      <DateButton @click="selectNonExisting(classCategory)"
            :id="classCategory" main-text="Kurstermin anfragen" 
          />
    </div>
    <div v-for="(dates, month) in coursesGroupedByMonth" :key="month" class="month-group">
      <h4 class="h4">{{ month }}</h4>
       <div class="flex flex-wrap gap-2">
          <DateButton v-for="(item, index) in dates" :key="index" @click="select(item, classCategory)"
            :id="item.id" 
            :main-text="item.from + ' - ' + item.to" 
            :secondary-text="'Kursbeginn am ' + item.day"
            :tertiary-text="resolveLocationName(item.standortId)"
            :is-selected="isSelected(item.id)"
          />
      </div>
    </div>
  </div>
  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, Navigation } from '../../models/enums'
import { resolveClassCategory, scrollToTop } from '../../models/helper'
import { useStore } from 'vuex';
import DateButton from '@/components/DateButton.vue';
import dayjs from 'dayjs';
import { dayJsDayToText, dayJsMonthToText, isEmpty } from '../../models/helper'
const store = useStore();
const nextDisabled = computed(() => !store.getters.LICENCE_COURSE_PER_CLASS_SELECTED);
const prev = () => {
  store.commit("resetSelectedCourses")
  store.commit("stepBack")
  scrollToTop();
};
const next = () => {
  store.commit("updateStep", DetailStep.PERSÖNLICHEDATEN);
  scrollToTop();
}
const select = (item, classs) => store.commit("updateSelectedCourses", { course: item, classs });
const selectNonExisting = (classs) => {
  const item = { id: classs };
  store.commit("updateSelectedCourses", { course: item, classs });
};

const isSelected = computed(() => {
  return (id) =>
    Object.values(store.state.selectedCourses ?? {})
      .flat()
      .some(course => course?.id == id);
});
store.dispatch("LOAD_COURSE_DATES");

const resolveLocationName = (id) => {
  return store.state.allLocations.find(location => location.ID === id)?.Bezeichnung;
};

const coursesGroupedByClassGroupedByMonth = computed(() => {
  const coursesGroupedByClass = store.getters.NEW_DRIVER_LICENCE_CLASSES_SUPER.reduce((acc, courseType) => {
    store.state.allCourses.forEach(course => {
      if (!acc[courseType]) acc[courseType] = [];
      if (course.klassen.includes(courseType)) acc[courseType].push(course);
    });
    return acc;
  }, {});

  for (const [key, courses] of Object.entries(coursesGroupedByClass)) {
    coursesGroupedByClass[key] = courses
      .filter(course => {
        const givenDate = dayjs(course.von);
        const currentDate = dayjs();
        return givenDate.isAfter(currentDate)
      })
      .reduce((acc, course) => {
        const courseFrom = dayjs(course.von);
        const courseTo = dayjs(course.bis);
        const month = dayJsMonthToText(courseFrom.month());

        if (!acc[month]) { acc[month] = []; }

        const preppedData = {
          id: course.id,
          name: course.bezeichnung,
          from: courseFrom.format('DD.MM.YYYY'),
          to: courseTo.format('DD.MM.YYYY'),
          day: dayJsDayToText(courseFrom.day()),
          standortId: course.standort_id,
        };
        acc[month].push(preppedData);

        return acc;
      }, {});
  }

  return coursesGroupedByClass;
});
</script>

<style scoped lang="scss">
h3 {
  @apply mb-4;
}
h4 {
  @apply mt-3 mb-2;
}
</style>